import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="w-full bg-footer-dark py-8 px-4" data-id="element-249">
        <div className="max-w-[680px] mx-auto text-center" data-id="element-250">
          <p className="font-body text-gray-400 text-sm mb-3" data-id="element-251">
            © 2024 Bikinis al Crochet — Todos los derechos reservados
          </p>
          <div className="flex items-center justify-center gap-4 font-body text-xs" data-id="element-252">
            <button onClick={() => setActiveModal('privacy')} className="text-gray-500 hover:text-pink-light transition-colors cursor-pointer underline underline-offset-2" data-id="element-253">
              Política de privacidad
            </button>
            <span className="text-gray-600" data-id="element-254">|</span>
            <button onClick={() => setActiveModal('terms')} className="text-gray-500 hover:text-pink-light transition-colors cursor-pointer underline underline-offset-2" data-id="element-255">
              Términos y condiciones
            </button>
          </div>
        </div>
      </footer>

      {/* Modal Overlay */}
      {activeModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-256">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg max-h-[80vh] overflow-hidden flex flex-col" onClick={e => e.stopPropagation()} data-id="element-257">
            {/* Modal Header */}
            <div className="flex items-center justify-between p-5 border-b border-gray-100" data-id="element-258">
              <h2 className="font-heading font-bold text-lg text-dark-gray" data-id="element-259">
                {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
              </h2>
              <button onClick={() => setActiveModal(null)} className="text-medium-gray hover:text-dark-gray transition-colors cursor-pointer p-1" aria-label="Cerrar" data-id="element-260">
                <XIcon className="w-5 h-5" data-id="element-261" />
              </button>
            </div>

            {/* Modal Content */}
            <div className="p-5 overflow-y-auto font-body text-dark-gray text-sm leading-relaxed space-y-4" data-id="element-262">
              {activeModal === 'privacy' ? <>
                  <p className="text-medium-gray text-xs" data-id="element-263">
                    Última actualización: Enero 2024
                  </p>

                  <h3 className="font-bold text-base" data-id="element-264">
                    1. Información que Recopilamos
                  </h3>
                  <p data-id="element-265">
                    Al realizar una compra, recopilamos tu nombre y dirección de
                    correo electrónico únicamente con el fin de entregarte el
                    producto digital adquirido.
                  </p>

                  <h3 className="font-bold text-base" data-id="element-266">
                    2. Uso de la Información
                  </h3>
                  <p data-id="element-267">Tu información personal se utiliza exclusivamente para:</p>
                  <ul className="list-disc pl-5 space-y-1" data-id="element-268">
                    <li data-id="element-269">Enviar el ebook a tu correo electrónico</li>
                    <li data-id="element-270">
                      Comunicarnos contigo en caso de ser necesario respecto a
                      tu compra
                    </li>
                    <li data-id="element-271">
                      Enviarte actualizaciones del producto si las hubiera
                    </li>
                  </ul>

                  <h3 className="font-bold text-base" data-id="element-272">
                    3. Protección de Datos
                  </h3>
                  <p data-id="element-273">
                    No vendemos, intercambiamos ni transferimos tu información
                    personal a terceros. Implementamos medidas de seguridad para
                    proteger tu información.
                  </p>

                  <h3 className="font-bold text-base" data-id="element-274">4. Cookies</h3>
                  <p data-id="element-275">
                    Nuestro sitio puede utilizar cookies para mejorar tu
                    experiencia de navegación. Podés desactivarlas en la
                    configuración de tu navegador.
                  </p>

                  <h3 className="font-bold text-base" data-id="element-276">5. Tus Derechos</h3>
                  <p data-id="element-277">
                    Tenés derecho a solicitar la eliminación de tus datos
                    personales en cualquier momento enviándonos un correo
                    electrónico.
                  </p>
                </> : <>
                  <p className="text-medium-gray text-xs" data-id="element-278">
                    Última actualización: Enero 2024
                  </p>

                  <h3 className="font-bold text-base" data-id="element-279">1. Producto Digital</h3>
                  <p data-id="element-280">
                    "Bikinis al Crochet" es un producto digital (ebook) que se
                    entrega en formato electrónico a través de correo
                    electrónico inmediatamente después de la compra.
                  </p>

                  <h3 className="font-bold text-base" data-id="element-281">2. Entrega</h3>
                  <p data-id="element-282">
                    El ebook se envía automáticamente al correo electrónico
                    proporcionado al momento de la compra. Si no recibís el
                    producto dentro de los 15 minutos posteriores a la compra,
                    revisá tu carpeta de spam.
                  </p>

                  <h3 className="font-bold text-base" data-id="element-283">
                    3. Garantía de Devolución
                  </h3>
                  <p data-id="element-284">
                    Ofrecemos una garantía de devolución de 7 días. Si no estás
                    satisfecha con el producto, podés solicitar un reembolso
                    completo dentro de los 7 días posteriores a la compra, sin
                    preguntas.
                  </p>

                  <h3 className="font-bold text-base" data-id="element-285">
                    4. Propiedad Intelectual
                  </h3>
                  <p data-id="element-286">
                    Todo el contenido del ebook está protegido por derechos de
                    autor. Al adquirir el producto, obtenés una licencia
                    personal e intransferible. No está permitida la
                    redistribución, reventa o reproducción del contenido.
                  </p>

                  <h3 className="font-bold text-base" data-id="element-287">
                    5. Uso de los Patrones
                  </h3>
                  <p data-id="element-288">
                    Los patrones incluidos en el ebook pueden ser utilizados
                    para crear piezas para uso personal o para venta. Sin
                    embargo, los patrones en sí no pueden ser compartidos ni
                    revendidos.
                  </p>

                  <h3 className="font-bold text-base" data-id="element-289">
                    6. Limitación de Responsabilidad
                  </h3>
                  <p data-id="element-290">
                    Los resultados pueden variar según la experiencia y
                    dedicación de cada persona. No garantizamos resultados
                    específicos ni ingresos derivados del uso del producto.
                  </p>
                </>}
            </div>

            {/* Modal Footer */}
            <div className="p-4 border-t border-gray-100" data-id="element-291">
              <button onClick={() => setActiveModal(null)} className="w-full py-2.5 bg-pink-dark text-white font-body font-bold text-sm rounded-full hover:bg-[#be1f68] transition-colors cursor-pointer" data-id="element-292">
                Cerrar
              </button>
            </div>
          </div>
        </div>}
    </>;
}